'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');
var amountFormatHelper = require('../utils/amountFormatHelper');
var base = require('base/product/base');

var $product = $('.product-tile').length ? $('.product-tile') : $('.product-detail');
var cartTitle = $product.data('carttitle');
var addMsg = $product.data('cartmsg');

/**
 * Handles adding DiamondOnCall products to cart
 */
module.exports = function () {
    /**
     * Add diamond product to cart
     */
    $(document).on('click', '.add-to-cart-diamond, .diamond-on-call-action-btns .add-diamond-buy-now', function (e) {
        e.preventDefault();
        $.spinner().stop();

        var $btn = $(this);
        var stockId = $btn.data('stock-id');
        var productName = $btn.data('product-name');
        var price = $btn.data('price');
        var image = $btn.data('image');

        // Validate required data
        if (!stockId || !price || !productName) {
            $btn.trigger('product:notValid');
            return;
        }

        // Disable button during request
        $btn.prop('disabled', true);

        // Step 1: Create product in catalog via OCAPI
        var createProductUrl = $btn.data('create-url') || $('.add-to-cart-diamond').data('create-url');

        if (!createProductUrl) {
            // console.error('Create product URL not found');
            $btn.prop('disabled', false);
            return;
        }

        var form = {
            stockId: stockId,
            productName: productName,
            image: image,
            price: price
        };

        $.spinner().start();

        $.ajax({
            url: createProductUrl,
            type: 'POST',
            dataType: 'json',
            data: form,
            success: function (createResponse) {
                if (createResponse.error) {
                    // console.error(createResponse.message || 'Unable to create diamond product');
                    $btn.prop('disabled', false);
                    return;
                }

                var buyNowBtn = $btn.hasClass('buy-now') || $btn.hasClass('add-diamond-buy-now');
                var guestUser = $btn.data('authcustomer') === false;

                if (buyNowBtn && guestUser && !$btn.hasClass('proceed-checkout')) {
                    $('.login-modal-result, .login-modal-missing-error, .login-modal-customer-exists-error, .login-mobile-country-miss-match-error, .guest-login-modal-subtitle').addClass('d-none');
                    $('.continue-as-guest-section').removeClass('d-none');
                    $('#guestLoginInput').val('');
                    $('.guest-continue-button').removeAttr('disabled');
                    $('#guestLoginInput').addClass('w-100');
                    $('.guest-country-select-wrap').addClass('d-none');
                    if ($btn.data('guestloginmessage')) {
                        var $guestSubtitle = $('.guest-login-modal-subtitle');
                        var subtitleTemplate = $guestSubtitle.data('template');

                        if (!subtitleTemplate) {
                            subtitleTemplate = $guestSubtitle.text();
                            $guestSubtitle.data('template', subtitleTemplate);
                        }

                        var rawAmount = $btn.data('guestloginamount');
                        if (subtitleTemplate && rawAmount !== null && rawAmount !== undefined) {
                            var formattedAmount = amountFormatHelper.formatGuestThresholdAmount(rawAmount);
                            $guestSubtitle.text(subtitleTemplate.replace(/\{0\}/g, formattedAmount));
                        }

                        $guestSubtitle.removeClass('d-none');
                        $('.guest-continue-button').attr('disabled', true);
                        $('.continue-as-guest-section').addClass('d-none');
                    }
                    var $guestWrapDrop = $('.ckc-guest-login-countrycode-drop-down');
                    $guestWrapDrop.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
                    var $guestDefaultOptions = $guestWrapDrop.find('.custom-option-value[data-id="+91"]');
                    $guestDefaultOptions.addClass('active selected');
                    $guestWrapDrop.find('.custom-drop-down-login .selected-value').text($guestDefaultOptions.data('id')).addClass('active');
                    $('#ckc-guest-login-modal').modal('show');
                    if ($btn.hasClass('buynow-button') || $btn.hasClass('buy-now') || $btn.hasClass('add-diamond-buy-now')) {
                        sessionStorage.setItem('buyNowProductId', $btn.attr('data-stock-id'));
                    }
                    $btn.prop('disabled', false);
                    $.spinner().stop();

                    return;
                }

                $.spinner().stop();
                $('body').trigger('product:beforeAddToCart', $btn);

                var isBuynow = $btn.hasClass('buy-now') || $btn.hasClass('add-diamond-buy-now');
                form.isBuyNowJourney = isBuynow;

                // Step 2: Add created product to cart
                var addToCartUrl = $btn.data('action-url') || $('.add-to-cart-diamond').data('action-url');

                $.ajax({
                    url: addToCartUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: form,
                    success: function (response) {
                        if (response.success || !response.error) {
                            // Update minicart
                            $('body').trigger('product:afterAddToCart', response);

                            // Show success message
                            $('.minicart').trigger('count:update', response);
                            $('.minicart-quantity').removeClass('d-none');
                            $.spinner().stop();

                            if (response.redirect) {
                                window.location.href = response.redirectUrl;
                            }

                            if (!isBuynow) {
                                base.miniCartReportingUrl(response.reportingURL);
                                toastMessageHelper.showNotification(cartTitle, addMsg, 'Basket-icon');
                            }

                            if (!response.redirect && response.cartUrl) {
                                window.location.href = response.cartUrl;
                            }
                        } else {
                            toastMessageHelper.showNotification('', response.message || 'Unable to add diamond to cart. Please try again.');
                        }
                        $.spinner().stop();
                        $btn.prop('disabled', false);
                    },
                    error: function () {
                        // console.error('Unable to add diamond to cart. Please try again.');

                        // Re-enable button
                        $.spinner().stop();
                        $btn.prop('disabled', false);
                    }
                });
            },
            error: function () {
                // console.error('Unable to create diamond product. Please try again.');

                // Re-enable button
                $.spinner().stop();
                $btn.prop('disabled', false);
            }
        });
    });
};
